var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.number)?_c('p',[_c('sensitive-data-wrapper',[(_vm.dnc)?[_c('del',[_vm._v(_vm._s(_vm.numberFormatted))]),_vm._v(" "),_c('small',[_vm._v("DNC")])]:[_vm._v(_vm._s(_vm.numberFormatted)+" "),(_vm.isPrimary)?_c('span',[_vm._v("(primary)")]):_vm._e()]],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }